<template>
  <div class="user">
    <div class="photo">
      <md-icon style="margin-left:5px; color: #FFF">calculator-variant</md-icon>
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li v-for="units in unitsOptions" v-bind:key="units">
                <a href="#" @click="SET_UNITS(units)">
                  
                  <span class="sidebar-normal">{{ units }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapMutations } from "vuex";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "Units",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
    avatar: {
      type: String,
      default: "./img/faces/avatar.jpg",
    },
  },
  data() {
    return {
      isClosed: true,
      unitsOptions: [],
    };
  },
  async mounted() {
    this.unitsOptions = ["Metric", "Imperial"];
  },

  methods: {
    ...mapMutations(["SET_UNITS"]),
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
